'use client';

import { ElementComponents } from '@/components/sections/builder/builder-element';
import { HeaderElementDataType } from '@/components/sections/builder/elements/header/header/type';
import BuilderPreviewPage from '@/components/sections/builder/preview-page';
import { WrapperTheme } from '@/components/sections/builder/wrapper';
import { CommonElementDataType, ElementType, ThemeType } from '@/stores/builder';
import { IBuilder } from '@/types/site';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

type PropsType = {
  data: IBuilder;
  host: string;
};

export default function NotFoundLive({ data, host }: PropsType) {
  const query = useSearchParams();
  const isPreview = query.get('isPreview') || false;
  const themeId = query.get('theme_id') || '';

  const builder = (data?.data || {}) as { elements: ElementType[]; theme: ThemeType };

  const elements = (builder.elements || [])
    .filter(
      (element) =>
        !(element.data as CommonElementDataType)?.hidden &&
        !!ElementComponents[element.type]?.Element
    )
    .map((element) => ({
      ...element,
      childs: element.childs?.filter((child) => !(child.data as CommonElementDataType)?.hidden),
    }));

  const headerElements = elements.filter((element) => element.group === 'header');
  const bodyElements = elements.filter((element) =>
    ['body', 'body_not_found'].includes(element.group)
  );
  const footerElements = elements.filter((element) => element.group === 'footer');

  const headerElement = headerElements.find((e) => e.type === 'header');
  const headerData = headerElement?.data as HeaderElementDataType;

  useEffect(() => {
    if (!isPreview) return;
    window.parent?.postMessage(
      {
        type: 'iframe_loaded',
        previewPath: 'not_found',
        themeId: themeId,
      },
      '*'
    );
  }, [isPreview]);

  if (!data || !builder.elements) return null;

  if (isPreview) return <BuilderPreviewPage groupBody='body,body_not_found' />;

  return (
    <WrapperTheme theme={builder.theme}>
      <link rel='icon' href={headerData?.faviconUrl} type='image/x-icon' />
      {headerElements.map((element) => {
        const Element = ElementComponents[element.type].Element;
        if (Element) return <Element element={element} key={element.id} theme={builder.theme} />;
      })}
      <div className='theme_layout_space_section flex-grow'>
        {bodyElements.map((element) => {
          const Element = ElementComponents[element.type].Element;
          if (Element)
            return <Element element={element} key={element.id} host={host} theme={builder.theme} />;
        })}
      </div>
      {footerElements.map((element) => {
        const Element = ElementComponents[element.type].Element;
        if (Element) return <Element element={element} key={element.id} />;
      })}
    </WrapperTheme>
  );
}
